import isObject from './isObject.js';

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {
	Vue.mixin({
		created() {
			if (isObject(this.$options) && typeof this.$options.meta === 'function') {
				const componentMeta = this.$options.meta.call(this);
				const storeMeta = this.$store.state.meta;
				const themeMeta = Object.assign({}, {
					title: componentMeta.title || storeMeta.title,
					link: Object.assign(storeMeta.link, componentMeta.link),
					script: Object.assign(storeMeta.script, componentMeta.script),
					noscript: Object.assign(storeMeta.noscript, componentMeta.noscript)
				});
				if (IS_CLIENT) {
					document.title = themeMeta.title;
				}
				this.$store.commit('SET_META', themeMeta);
			}
		}
	});
};

export default {
	install
};
